import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import SocialsPage from './pages/SocialsPage';
import SocialCalendarPage from './pages/SocialCalendarPage';
import MembershipPage from './pages/MembershipPage';
import MemberBenefitsPage from './pages/MemberBenefitsPage';
import NewsPage from './pages/NewsPage';
import EventsPage from './pages/EventsPage';
import BonfirePage from './pages/BonfirePage';
import HeritageProgrammePage from './pages/HeritageProgrammePage';
import GlossFestPage from './pages/GlossFestPage';
import CharityBarPage from './pages/CharityBarPage';
import SitemapPage from './pages/SitemapPage';
import DataProtectionPage from './pages/DataProtectionPage';
import CookiesPage from './pages/CookiesPage';
import AntiSlaveryPage from './pages/AntiSlaveryPage';
import AntiBriberyPage from './pages/AntiBriberyPage';
import AntiRacismPage from './pages/AntiRacismPage';
import AdminBonfireSignupsPage from './pages/AdminBonfireSignupsPage';
import AdminContactEnquiriesPage from './pages/AdminContactEnquiriesPage';
import AdminDonationRequestsPage from './pages/AdminDonationRequestsPage';
import AdminUsersPage from './pages/AdminUsersPage';
import AdminProfilePage from './pages/AdminProfilePage';
import AdminSweetJarPage from './pages/AdminSweetJarPage';
import DonationRequestPage from './pages/DonationRequestPage';
import UnsubscribePage from './pages/UnsubscribePage';
import NotFoundPage from './pages/NotFoundPage';
import SweetJarPage from './pages/SweetJarPage';
import CharityBarBackupPage from './pages/CharityBarBackupPage';
import VolunteerPage from './pages/VolunteerPage';
import AdminHomePage from './pages/AdminHomePage';
import CharitiesPage from './pages/CharitiesPage';
import SupportersPage from './pages/SupportersPage';
import ContactPage from './pages/ContactPage';

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  React.useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        // Defer to next frame so the target route has rendered
        requestAnimationFrame(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }));
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

// Strip any trailing slash from the current URL (except the root) so shared/bookmarked
// links with a trailing slash self-correct in the address bar. Prevents Google
// from discovering and indexing `/about/` as an alternate of `/about`.
function NormalizeTrailingSlash() {
  const { pathname, search, hash } = useLocation();
  React.useEffect(() => {
    if (pathname !== '/' && pathname.endsWith('/')) {
      const cleaned = pathname.replace(/\/+$/, '') + search + hash;
      window.history.replaceState(null, '', cleaned);
    }
  }, [pathname, search, hash]);
  return null;
}

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <NormalizeTrailingSlash />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/socials" element={<SocialsPage />} />
            <Route path="/social-calendar" element={<SocialCalendarPage />} />
            <Route path="/membership" element={<MembershipPage />} />
            <Route path="/member-benefits" element={<MemberBenefitsPage />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/volunteer" element={<VolunteerPage />} />
            <Route path="/charities" element={<CharitiesPage />} />
            <Route path="/supporters" element={<SupportersPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/bonfire" element={<BonfirePage />} />
            <Route path="/heritage-programme" element={<HeritageProgrammePage />} />
            <Route path="/glossfest" element={<GlossFestPage />} />
            <Route path="/charity-bar" element={<CharityBarPage />} />
            <Route path="/round-table-bar" element={<CharityBarPage />} />
            <Route path="/round-table-bar-backup" element={<CharityBarBackupPage />} />
            <Route path="/sitemap" element={<SitemapPage />} />
            <Route path="/policies/data-protection" element={<DataProtectionPage />} />
            <Route path="/policies/cookies" element={<CookiesPage />} />
            <Route path="/policies/anti-slavery" element={<AntiSlaveryPage />} />
            <Route path="/policies/anti-bribery" element={<AntiBriberyPage />} />
            <Route path="/policies/anti-racism" element={<AntiRacismPage />} />
            <Route path="/admin" element={<AdminHomePage />} />
            <Route path="/admin/bonfire-signups" element={<AdminBonfireSignupsPage />} />
            <Route path="/admin/contact-enquiries" element={<AdminContactEnquiriesPage />} />
            <Route path="/admin/donation-requests" element={<AdminDonationRequestsPage />} />
            <Route path="/admin/sweet-jar" element={<AdminSweetJarPage />} />
            <Route path="/admin/users" element={<AdminUsersPage />} />
            <Route path="/admin/profile" element={<AdminProfilePage />} />
            <Route path="/donation-request" element={<DonationRequestPage />} />
            <Route path="/sweet-jar" element={<SweetJarPage />} />
            <Route path="/unsubscribe/:token" element={<UnsubscribePage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
